const home = {
  'home.mint.btn': 'Mint',
  'home.nowhitelist.tips': 'User address is not whitelisted',
  'home.success.tips': 'Successfully cast',
  'home.nft.title': 'NFT Description',
  'home.title': 'GlassesPaw',
  'home.sub.title.1':
    '這是DePIN Nodechain Era Pte. Ltd推出的NFT，象徵著物理世界與區塊鏈之間的橋樑，是持有者在公司中權益的直觀證明，代表著對DePIN項目的深度參與和未來收益的分享。',
  'home.sub.title.2':
    '透過持有NFT，您將成為推動AI數據鏈及生態發展的關鍵力量，見證並參與物理世界與區塊鏈融合的偉大進程。DePIN NFT不僅是數位時代的股權憑證，更是連接未來、創造價值的通行證。',
}

export default home
